import { z } from "zod";

import { ServiceEntity } from "../../../model";

import { ServiceCategoryEntity } from "~/entities/service-category/@x/service";

const zOutSchema = ServiceEntity.zSchema
  .pick({
    id: true,
    price: true,
    imageId: true,
    isActive: true,
  })
  .extend({
    name: ServiceEntity.zPossiblyEmptyName.nullable(),
    description: ServiceEntity.zSchema.shape.description.nullable(),
    category: ServiceEntity.zSchema.shape.category
      .pick({
        id: true,
      })
      .extend({
        name: ServiceCategoryEntity.zPossiblyEmptyName.nullable(),
        description: ServiceCategoryEntity.zPossiblyEmptyDescription.nullable(),
      }),
    features: z.array(
      ServiceEntity.zSchema.shape.features.element
        .pick({
          id: true,
        })
        .extend({
          name: ServiceEntity.zPossiblyEmptyFeatureName.nullable(),
          description: ServiceEntity.zSchema.shape.features.element.shape.description.nullable(),
        }),
    ),
  });
type OutSchema = z.infer<typeof zOutSchema>;

export { zOutSchema };
export type { OutSchema };
